import http from "../../../http-common-super-admin";

class OrdersDataService {
    orderList(data) {
        return http.get("/kids/order/list", { params: data });
    }
    orderDetail(data) {
        return http.get("/kids/order/detail", { params: data });
    }
    updateStatus(data) {
        return http.post("/kids/order/update/status", data);
    }
    updateNotes(data) {
        return http.post("/kids/order/update/notes", data);
    }
    allocateDevice(data) {
        return http.post("/kids/order/device/allocation", data);
    }
    getProfileDetail(data) {
        return http.post("/kids/order/device/profile-detail", data);
    }
    wingioProductsList() {
        return http.get("/kids/product/list");
    }
    getWingioProductImages(data) {
        return http.get("/kids/product/images", { params: data });
    }
    uploadWingioProductImages(formData) {
        return http.post("/kids/product/upload-product-images", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
    }
    deleteWingioProductImages(data) {
        return http.delete("/kids/product/image", { params: data });
    }      
    updateProductDetails(data) {
        return http.post("/kids/product/update", data);
    }
    createProduct(data) {
        return http.post("/kids/product/create", data);
    }
    deleteWingioProduct(data) {
        return http.delete("/kids/product/delete", { params: data });
    } 
    getWingioProductPrices(data) {
        return http.get("/kids/product/prices", { params: data });
    }
    addNewPrice(data) {
        return http.post("/kids/product/price/add", data);
    }
    onDefaultChange(data) {
        return http.post("/kids/product/price/default", data);
    }
    getWingioProductShippingPrices(data) {
        return http.get("/kids/product/shipping/prices", { params: data });
    }
    addNewShippingPrice(data) {
        return http.post("/kids/product/shipping/price/add", data);
    }
    toggleActiveShippingPrice(data) {
        return http.post("/kids/product/shipping/price/active", data);
    }
    clearDeviceConfigurationData(data) {
        return http.post("/kids/order/clear/config/data", data);
    }
    createRoyalMailOrder(data) {
        return http.post("/kids/order/royal-mail/order", data);
    }
    getRoyalMailOrder(data) {
        return http.get("/kids/order/royal-mail/order", { params: data});
    }
    paymentHistory(data) {
        return http.get("/kids/order/payment-history", { params: data});
    }

    // ── Accessories: Onetime products list (for parent-product selector) ─────
    getOnetimeProducts() {
        return http.get("/kids/product/onetime");
    }

    // ── Accessories: Colour Variants ─────────────────────────────────────────
    addColorVariant(data) {
        return http.post("/kids/product/color-variant/add", data);
    }
    updateColorVariant(data) {
        return http.post("/kids/product/color-variant/update", data);
    }
    deleteColorVariant(data) {
        return http.delete("/kids/product/color-variant/delete", { params: data });
    }

    // ── Accessories: Colour Variant Images ───────────────────────────────────
    deleteColorVariantImage(data) {
        return http.delete("/kids/product/color-variant/image/delete", { params: data });
    }
    // Add this method to the existing class:
    getMarketplaces() {
        return http.get("/kids/marketplace/list");
    }
    referralTransactionsList(data) {
        return http.get("/kids/order/referral-transactions", { params: data });
    }
    approveReferralTransaction(data) {
        return http.post("/kids/order/referral-transactions/approve", data);
    }
    releaseReferralReward(data) {
        return http.post("/kids/order/referral-transactions/release", data);
    }
    allocateRequiredApps(data) {
        return http.post("kids/order/device/allocate-required-apps", data);
    }
}

export default new OrdersDataService();